/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LocationSignpostRightIcon20Solid = forwardRef('LocationSignpostRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.25 1.5a1.25 1.25 0 1 0-2.5 0V3H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4.75v6.75a1.25 1.25 0 1 0 2.5 0V11h3.422a2 2 0 0 0 1.414-.586l2.6-2.6a1.15 1.15 0 0 0 0-1.627l-2.6-2.601A2 2 0 0 0 14.672 3H11.25V1.5Z" })));
});
